import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class ExcelExportService {
  exportToExcel(
    data: any[],
    filename: string,
    sheetName: string = 'Sheet1',
    wrapColumns: string[] = [],
    headerMap?:any
  ) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(sheetName);

    let headers = Object.keys(data[0]);
    if(headerMap){
      headers = headers.map(h => headerMap[h] || h);
    }
    const rows = data.map((row) => headers.map((header) => row[header]));
    worksheet.addRow(headers);

    // Style headers
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getRow(1).height = 20; // Set header row height

    // Add data rows
    rows.forEach((row) => {
      worksheet.addRow(row);
    });

    // Adjust column widths dynamically
    headers.forEach((header, index) => {
      const maxLength = Math.max(
        header.length,
        ...data.map((row) => (row[header] || '').toString().length)
      );
      worksheet.getColumn(index + 1).width = maxLength + 2; // Add padding
    });

    // Apply wrap text and styling 
    wrapColumns.forEach((col) => {
      const columnIndex = headers.indexOf(col) + 1;
      if (columnIndex > 0) {
        worksheet.getColumn(columnIndex).alignment = { wrapText: true };
      }
    });

    // Save the file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `${filename}.xlsx`);
    });
  }

  exportToExcelWithHeaderMap(
    data: any[],
    filename: string,
    headerMap: { [key: string]: string },
    sheetName: string = 'Sheet1',
    wrapColumns: string[] = []
  ) {
    if (!data || data.length === 0) {
      return;
    }

    // Create a new array with readable header names as keys
    const formattedData = data.map(row => {
      const newRow: any = {};

      Object.keys(row).forEach(key => {
        newRow[headerMap[key] || key] = row[key];
      });

      return newRow;
    });

    // Convert wrap columns to readable names as well
    const formattedWrapColumns = wrapColumns.map(
      col => headerMap[col] || col
    );

    // Reuse the existing method
    this.exportToExcel(
      formattedData,
      filename,
      sheetName,
      formattedWrapColumns
    );
  }
}

